import { render, staticRenderFns } from "./ranking.vue?vue&type=template&id=5fc909d4&scoped=true&"
import script from "./ranking.vue?vue&type=script&lang=js&"
export * from "./ranking.vue?vue&type=script&lang=js&"
import style0 from "./ranking.vue?vue&type=style&index=0&id=5fc909d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc909d4",
  null
  
)

export default component.exports